import {listCost} from "@/api/admin/costs";

const state = ()=>({
    listCost: []
})

const getters = {
    getListCost(state){
        return state.listCost
    }
}

const mutations = {
    SET_LIST_COST (state, data) {
        state.listCost = data;
    },

}


const actions = {
    async fetchListCost({commit}){
        try {
            let res = await listCost();
            commit('SET_LIST_COST', res.data);
        }
        catch (e){
        //
        }
    },

}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
